// extracted by mini-css-extract-plugin
export default {"mainContainer":"navbar_mainContainer__5MsdU","mainContainerDark":"navbar_mainContainerDark__smHV0","mainContainerSmall":"navbar_mainContainerSmall__-rMRi"};